import { module } from 'stereomodularjs';
import { html } from '../utils/environment'

export default class extends module {
    constructor(m) {
        super(m);
        this.contentSelect = document.querySelector('#content-select');
    }

    init() {
        this.contentSelect.addEventListener('change', (e) => {
            this.updateContent();
        })
        if (this.contentSelect.value == 0 && document.querySelector('.js-dynamic-content__item__' + this.contentSelect.value)){
            document.querySelector('.js-dynamic-content__item__'+this.contentSelect.value).classList.add('is-active');
        }
    }

    updateContent(){
        classRemove(document.querySelector('.c-dynamic-content__item.is-active'), 'is-active');
        if(this.contentSelect.value >= 1){
            document.querySelector('.js-dynamic-content__item__'+this.contentSelect.value).classList.add('is-active');
        }else{
            if(this.contentSelect.value == 0 && document.querySelector('.js-dynamic-content__item__'+this.contentSelect.value)){
                document.querySelector('.js-dynamic-content__item__'+this.contentSelect.value).classList.add('is-active');
            }
        }
    }
    
    destroy(){
        // eventRemove(this.contentSelect, 'change', (e) => {
        //     this.updateContent();
        // })
    }
}
